import { render } from "./Memo.vue?vue&type=template&id=29c7eb57&scoped=true"
import script from "./Memo.vue?vue&type=script&lang=js"
export * from "./Memo.vue?vue&type=script&lang=js"

import "./Memo.vue?vue&type=style&index=0&id=29c7eb57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29c7eb57"

export default script